import { assertIsError } from '../../utils/assert-is-error';
import { logger } from '../../utils/logger';
import { parse } from './serialisation/parse';
import { stringify } from './serialisation/stringify';
import { getStorageKey } from './storage-key';
import { isOutOfSpaceStorageError, isStorageSupported } from './storage-utils';
export const createStorageCache = (storage, key) => {
    if (!isStorageSupported(storage)) {
        throw new Error('Could not create storage cache. Environment does not support storage.');
    }
    const storageKey = getStorageKey(key);
    return {
        getValue: () => {
            try {
                const storedValue = storage.getItem(storageKey);
                return storedValue ? parse(storedValue) : undefined;
            }
            catch (error) {
                logger.error(`Could not get stored item with key ${storageKey}.`, error);
                throw error;
            }
        },
        setValue: (value) => {
            const serializedValue = stringify(value);
            try {
                storage.setItem(storageKey, serializedValue);
            }
            catch (error) {
                assertIsError(error);
                if (isOutOfSpaceStorageError(error)) {
                    logger.error(`Insufficient space to store item with key ${storageKey}.`, error);
                }
                else {
                    logger.error(`Unexpected storage error: could not store item with key ${storageKey}.`, error);
                }
                throw error;
            }
        }
    };
};
//# sourceMappingURL=create-storage-cache.js.map